module.exports = __webpack_public_path__ + "static/4_2_recommendation_LT-6a491811a35adcc1d4770e6f07e5271b.svg";